import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, Spinner, Progress } from 'reactstrap';
import axios from "axios";
import { t } from 'i18next';
import './style.css';
import { BACKEND_URL_DOC } from "../../config/const.js";
const QuizList = ({ openQuizList, onCloseQuizList, startDate, endDate, groupId, type, typeDoc, teamArray }) => {
    const [quizList, setQuizList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (openQuizList) {
            fetchQuizList();
        }
    }, [openQuizList]);

    const fetchQuizList = async () => {
        setLoading(true);
        setError(null);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            };

            const response = await axios.post(BACKEND_URL_DOC+ "getQuizsDetails", {
                startDate,
                endDate,
                clientId: groupId,
                typeFilter: typeDoc.value,
                teamArray: teamArray || "",
                type: type // 'succeded', 'notCompleted', 'completed'
            }, config);

            setQuizList(response); // 🛠️ Assurez-vous d'accéder à `response.data`
        } catch (error) {
            setError("Erreur lors de la récupération des données.");
            console.error("Erreur API:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={openQuizList} centered size="lg">
            <ModalHeader className="detail-header" style={{ width: '100%' }}>
                <div className="modal-header-content">
                    <span className="modal-title">
                    {type === 'notCompleted'
                    ? t("quizNotCompleted")
                    : type === 'completed'
                    ? t("quizCompleted")
                    : t("quizSuccess")} 
                    </span>
                    <Button className="cancel-btn" onClick={onCloseQuizList}>
                        {t('CLOSE')}
                    </Button>
                </div>
            </ModalHeader>
            <ModalBody className="modal-body-custom">
                {loading ? (
                    <div className="text-center mt-5">
                        <Spinner color="primary" style={{ height: '3rem', width: '3rem' }}>Loading...</Spinner>
                        <div className="text-center mt-2">{t("loading...")}</div>
                    </div>
                ) : error ? (
                    <p style={{ color: "red" }}>{error}</p>
                ) : quizList && quizList.length > 0 ? (
                    <div className="log-container">
                        <table className="log-table">
                            <thead>
                                <tr>
                                    <th>{t("Title")}</th>
                                    <th>{t("User")}</th>
                                    <th>{t("Trials")}</th>
                                    <th>{t("Result")}</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: 'black' }}>
                                {quizList.map((rea, index) => (
                                    <tr key={index} className="row-doc">
                                        <td>{rea.title || t("Untitled Quiz")}</td>
                                        <td>{rea.username}</td>
                                        <td>{rea.trials}</td>
                                        <td>
                                            <div style={{ textAlign: "center" }}>{`${rea.result}%`}</div>
                                            <Progress
                                                animated
                                                striped
                                                value={rea.result}
                                                style={{ textAlign: "center", color: 'black' }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-center text-muted">{t('No Data Found')}</p>
                )}
            </ModalBody>
        </Modal>
    );
};

export default QuizList;
